(function () {
    'use strict';

    run.admin.parts.rackootTilesSize = function() {
        // Tools size
        document.body.addEventListener('click', function(e) {
            let size_button = e.target.closest('.rackoot__size_change');
            let size_icons = document.querySelectorAll('.rackoot__size_change');

            if (size_button) {
                [].forEach.call(size_icons, function(icon) {
                    icon.classList.remove('current');
                })
                size_button.classList.add('current');
    
                let size = size_button.dataset.size;
                let tools = document.querySelectorAll('.tools_grid');
                [].forEach.call(tools, function(tool) {
                    tool.dataset.toolSize = size;
                });

                setCookie('tool_size', size, 180);
                // window.localStorage.setItem('tool_size', size);
            }
        });
    }
})();
